import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { has_reference_objects } from '../../non_graphical_ui_actions';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import reduced_stl_button from '../../../assets/img/SVG_icons/Top/reference_operation/save_reduced_stl.svg';
import { img } from '@phi/components';
import { SessionType } from '@phi/authentication/frontend';
import { save_reduced_STL } from '@frontend/import_3d_scan_data';
import CompressSTLTooltip from './CompressSTLTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const CompressSTLIcon = reduced_stl_button;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
        session_type: {
            required: true,
            type: null as any as PropType<Set<SessionType>>,
        },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Save reduced version of STL';
        },

        disabled() {
            return !this.state.loaded
                || (
                    this.state.framework !== 'onshape'
                    && !this.session_type.has('onshape')
                )
                || !this.state.showing_reference_stl
                || !has_reference_objects();
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.subscriptions.state.subscription_status.value === 'starter')
                this.subscriptions.show_pro_feature_modal();
            else
                save_reduced_STL();
        },
    },

    render() {
        return h(BarButton, {
            id: 'save-reduced-stl-button',
            tippy: 'top',
            onClick: this.onClick,
            disabled: this.disabled,
            active: false,
            selected: this.state.tut_stage === 13,
            help: 'reduce_stl',
            pro_indicator: this.subscriptions.state.subscription_status.value === 'starter',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(reduced_stl_button, this.alt),
            tooltip: CompressSTLTooltip,
        });
    },
});
